import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AnalitycsService } from 'src/app/shared/service/analitycs.service';
import moment from 'moment';

@Component({
  selector: 'app-vehicle',
  templateUrl: './vehicle.component.html',
  styleUrl: './vehicle.component.css',
})
export class VehicleComponent {
  vehicle: any[] = [
    { plate: '../../../../../../assets/images/plate1.png', car: '../../../../../../assets/images/car1.png' },
    {
      plate: '../../../../../../assets/images/plate.png',
      car: 'https://images.ctfassets.net/x7j9qwvpvr5s/3nNxSK1xQLESBdlyU5Eur0/89de1e6ada14da2f854efeed352b6ca7/Ducati-Unica-Model-Preview-1050x650.png',
    },
    { plate: '../../../../../../assets/images/plate2.png', car: '../../../../../../assets/images/car2.png' },
  ];

  constructor(
    private router: Router,
    private analitycs: AnalitycsService,
  ) {
    this.analitycs.logEvent('INIT_VEHICLE', {
      view: 'VEHICLE',
      action: 'click',
      at: moment().format('YYYY-MM-DD HH:mm:ss'),
    });
  }
  Plate() {
    this.analitycs.logEvent('SEE_PLATE', {
      view: 'VEHICLE',
      action: 'click',
      at: moment().format('YYYY-MM-DD HH:mm:ss'),
    });
    this.router.navigate(['/plate']);
  }
  openPlateCityModal(): void {
    const modal = document.getElementById('platecityModal');
    if (modal) {
      modal.classList.remove('hidden'); // Mostrar el modal
    }
  }
  closePlateCityModal(): void {
    const modal = document.getElementById('platecityModal');
    if (modal) {
      modal.classList.add('hidden'); // Ocultar el modal
    }
  }
}
